import React, { useRef, useState } from 'react';

const LazyLoad = ({ children, mounted }) => {
  const [active, setActive] = useState();
  const widgetRef = useRef(null);

  const intersectHandler = ([entry]) => {
    if (entry.isIntersecting) {
      setActive(true);
    }
  };

  React.useEffect(() => {
    if (mounted) {
      const observer = new IntersectionObserver(intersectHandler, {
        threshold: 0.15,
      });

      if (widgetRef.current) {
        observer.observe(widgetRef.current);
      }

      return () => {
        setActive(false);
        observer.disconnect();
      };
    }
  }, [mounted]);

  return <div ref={widgetRef}>{children({ active })}</div>;
};

export default LazyLoad;
